var building_restrictions ={
  building_restrictions: {
    age_restricted: {
    txt_id: "age_restricted",
    name: "Age Restricted",
    description: "Age Restricted"
    },
    age_restriction_19_plus: {
    txt_id: "age_restriction_19_plus",
    name: "Age restriction 19+",
    description: "Age restriction 19+"
    },
    age_restriction_40_plus: {
    txt_id: "age_restriction_40_plus",
    name: "Age Restriction 40+",
    description: "Age Restriction 40+"
    },
    age_restriction_45_plus: {
    txt_id: "age_restriction_45_plus",
    name: "Age restriction 45+",
    description: "Age restriction 45+"
    },
    age_restriction_50_plus: {
    txt_id: "age_restriction_50_plus",
    name: "Age Restriction 50+",
    description: "Age Restriction 50+"
    },
    age_restriction_55_plus: {
    txt_id: "age_restriction_55_plus",
    name: "Age restriction 55+",
    description: "Age restriction 55+"
    },
    cats_allowed: {
    txt_id: "cats_allowed",
    name: "Cats Allowed",
    description: "Cats Allowed"
    },
    cats_not_allowed: {
    txt_id: "cats_not_allowed",
    name: "Cats Not Allowed",
    description: "Cats Not Allowed"
    },
    dogs_allowed: {
    txt_id: "dogs_allowed",
    name: "Dogs Allowed",
    description: "Dogs Allowed"
    },
    dogs_not_allowed: {
    txt_id: "dogs_not_allowed",
    name: "Dogs Not Allowed",
    description: "Dogs Not Allowed"
    },
    max_1_pet_allowed: {
    txt_id: "max_1_pet_allowed",
    name: "Maximum 1 Pet",
    description: "Maximum 1 Pet"
    },
    max_2_pets_allowed: {
    txt_id: "max_2_pets_allowed",
    name: "Maximum 2 Pets",
    description: "Maximum 2 Pets"
    },
    no_of_pets_2: {
    txt_id: "no_of_pets_2",
    name: "Maximum 2 Pets",
    description: "Maximum 2 Pets"
    },
    no_rentals_allowed: {
    txt_id: "no_rentals_allowed",
    name: "No rentals allowed",
    description: "No rentals allowed"
    },
    no_smoking_allowed: {
      txt_id: "no_smoking_allowed",
      name: "No Smoking Allowed",
      description: "No Smoking Allowed"
    },
    pets_allowed: {
    txt_id: "pets_allowed",
    name: "Pets Allowed",
    description: "Pets Allowed"
    },
    pets_not_allowed: {
    txt_id: "pets_not_allowed",
    name: "Pets Not Allowed",
    description: "Pets Not Allowed"
    },
    rentals_allowed: {
    txt_id: "rentals_allowed",
    name: "Rentals allowed",
    description: "Rentals allowed"
    },
    rentals_allowed_with_restrictions: {
    txt_id: "rentals_allowed_with_restrictions",
    name: "Rentals allowed with restrictions",
    description: "Rentals allowed with restrictions"
    },
    pets_allowed_with_restrictions: {
      txt_id: "pets_allowed_with_restrictions",
      name: "Pets Allowed With Restrictions",
      description: "Pets Allowed With Restrictions"
    }  
  }
}

module.exports = building_restrictions
